/* @sravni/react-design-system version 0.2.65 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { SizeContextProvider } from './SizeContext.js';
import modules_28f16a69 from '../styles/Avatar.module.less.js';

/**
 * @description AvatarGroup component.
 *
 * @component
 * @example
 * ```jsx
 * <AvatarGroup size="m">
 *  <Avatar src="image.png" />
 *  <Avatar src="image.png" />
 * </AvatarGroup>
 * ```
 */
var AvatarGroup = React.forwardRef(function (props, ref) {
    var size = props.size, className = props.className, children = props.children, restProps = __rest(props, ["size", "className", "children"]);
    var cx = useStyles(modules_28f16a69);
    var classNames = cx(className, 'group');
    return (React.createElement("div", __assign({ ref: ref, "data-qa": "AvatarGroup", className: classNames }, restProps),
        React.createElement(SizeContextProvider, { size: size }, children)));
});
AvatarGroup.defaultProps = {
    size: 36,
};
AvatarGroup.displayName = 'AvatarGroup';

export default AvatarGroup;
//# sourceMappingURL=AvatarGroup.js.map
